import InDocDiagramFrame from './InDocDiagramFrame';
import { inDocPalette, inDocType } from './inDocPalette';
import {
  InDocDefs,
  InDocGrid,
  InDocSectionLabel,
  InDocPanel,
  InDocConnector,
} from './inDocDiagramKit';

const PREFIX = 'indocScope';

const InDocScopeDiagram = ({ theme = 'dark' }) => {
  const isDark = theme === 'dark';
  const c = inDocPalette(isDark);

  return (
    <InDocDiagramFrame
      theme={theme}
      caption="The Role's Files Only. The Rest Do Not Appear."
      className="indoc-scope-frame"
    >
      <svg
        viewBox="0 0 720 380"
        className="w-full h-auto indoc-scope-svg"
        role="img"
        aria-label="Access is checked in the tool. Files the role may see can be searched and cited. The rest never appear."
      >
        <InDocDefs prefix={PREFIX} isDark={isDark} />
        <rect width="720" height="380" fill={c.bg} />
        <InDocGrid width={720} height={380} c={c} rows={7} />

        <InDocSectionLabel x={360} y={36} c={c}>
          SCOPE IS APPLIED AT THE TOOL
        </InDocSectionLabel>

        <InDocPanel x={48} y={72} w={140} h={120} prefix={PREFIX} c={c}>
          <text
            x={118}
            y={100}
            textAnchor="middle"
            fill={c.muted}
            {...inDocType.section}
          >
            THE ROLE
          </text>
          <text
            x={118}
            y={128}
            textAnchor="middle"
            fill={c.label}
            {...inDocType.title}
          >
            Authenticated
          </text>
          <text
            x={118}
            y={148}
            textAnchor="middle"
            fill={c.mono}
            {...inDocType.monoSm}
          >
            Role · Attribute
          </text>
          <text
            x={118}
            y={168}
            textAnchor="middle"
            fill={c.muted}
            {...inDocType.monoSm}
          >
            JWT · MFA
          </text>
        </InDocPanel>

        <InDocConnector
          x1={188}
          y1={132}
          x2={236}
          y2={132}
          c={c}
          prefix={PREFIX}
        />

        <InDocPanel
          x={240}
          y={64}
          w={168}
          h={136}
          prefix={PREFIX}
          c={c}
          active
          className="indoc-scope-gate"
        >
          <circle
            cx="324"
            cy="112"
            r="22"
            fill="none"
            stroke={c.sky}
            strokeWidth="1.5"
            className="indoc-scope-gate-ring"
          />
          <text
            x="324"
            y="116"
            textAnchor="middle"
            fill={c.accent}
            fontSize="9"
            fontWeight="800"
          >
            GATE
          </text>
          <text
            x="324"
            y="156"
            textAnchor="middle"
            fill={c.label}
            {...inDocType.title}
          >
            RBAC · ABAC
          </text>
          <text
            x="324"
            y={176}
            textAnchor="middle"
            fill={c.muted}
            {...inDocType.monoSm}
          >
            Same Set As The Rest
          </text>
        </InDocPanel>

        <InDocConnector
          x1={408}
          y1={108}
          x2={456}
          y2={108}
          c={c}
          prefix={PREFIX}
        />
        <InDocConnector
          x1={408}
          y1={156}
          x2={456}
          y2={220}
          c={c}
          prefix={PREFIX}
          dashed
        />

        <InDocPanel x={460} y={64} w={212} h={100} prefix={PREFIX} c={c}>
          <text
            x={566}
            y={88}
            textAnchor="middle"
            fill={c.emerald}
            {...inDocType.section}
          >
            IN SCOPE
          </text>
          <text
            x={566}
            y={112}
            textAnchor="middle"
            fill={c.label}
            {...inDocType.sub}
          >
            Search · Read · Summarize · Compare
          </text>
          <text
            x={566}
            y={134}
            textAnchor="middle"
            fill={c.mono}
            {...inDocType.monoSm}
          >
            Observable · Citable
          </text>
          <circle
            cx="566"
            cy="150"
            r="4"
            fill={c.emerald}
            filter={`url(#${PREFIX}-glow)`}
            className="indoc-scope-pass-dot"
          />
        </InDocPanel>

        <InDocPanel x={460} y={184} w={212} h={88} prefix={PREFIX} c={c}>
          <text
            x={566}
            y={208}
            textAnchor="middle"
            fill={c.rose}
            {...inDocType.section}
          >
            OUT OF SCOPE
          </text>
          <text
            x={566}
            y={230}
            textAnchor="middle"
            fill={c.label}
            {...inDocType.sub}
          >
            Never Listed · Never Read
          </text>
          <text
            x={566}
            y={250}
            textAnchor="middle"
            fill={c.mono}
            {...inDocType.monoSm}
          >
            Hold · No Observation
          </text>
        </InDocPanel>

        <circle
          r="5"
          fill={c.sky}
          filter={`url(#${PREFIX}-glow)`}
          className="indoc-scope-token"
        >
          <animateMotion
            dur="5s"
            repeatCount="indefinite"
            path="M 118 132 L 324 132 L 566 108"
          />
        </circle>

        <InDocPanel x={48} y={292} w={624} h={60} prefix={PREFIX} c={c}>
          <text x={64} y={316} fill={c.muted} {...inDocType.section}>
            LEDGER
          </text>
          <text
            x={64}
            y={336}
            fill={c.mono}
            {...inDocType.mono}
            className="indoc-scope-ledger"
          >
            thought → tool → observation → citation · each step retained
          </text>
          <rect
            x={520}
            y={310}
            width="128"
            height="24"
            rx="12"
            fill="none"
            stroke={c.amber}
            strokeWidth="1"
            className="indoc-scope-badge"
          />
          <text
            x={584}
            y={326}
            textAnchor="middle"
            fill={c.amber}
            fontSize="8"
            fontWeight="700"
            letterSpacing="1.5"
          >
            AUDIT READY
          </text>
        </InDocPanel>
      </svg>
    </InDocDiagramFrame>
  );
};

export default InDocScopeDiagram;
